'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderAddConfirmationComponent = exports.podOrderAddConfirmationComponent = {
    template: require('./pod-order-add-confirmation.html'),
    controllerAs: 'vm',
    bindings: {
        order: '<'
    },
    controller: function podOrderAddrConfirmationController() {
        'ngInject';
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-add-confirmation.js
// module id = 862
// module chunks = 0